import clsx from 'clsx';
import {CheckCircleBoldIcon} from '@solar-icons/react';
import styles from './ClockWidget.module.css';

const TICKS = Array.from({length: 12}, (_, i) => ({rotate: i * 30, height: i % 3 === 0 ? 12 : 7}));

/** Clock hands sweep to 6:29, the digits type in, then the answer confirms. Resolves to 6:29 by default. */
export default function ClockWidget({playing}) {
    return (
        <>
            <span className={styles.prompt}>Enter the time shown on this clock.</span>
            <div className={styles.row}>
                <div className={styles.face}>
                    {TICKS.map((tick, i) => (
                        <div key={i} className={styles.tickWrap} style={{transform: `rotate(${tick.rotate}deg)`}}>
                            <span className={styles.tick} style={{height: `calc(var(--px) * ${tick.height})`}}/>
                        </div>
                    ))}
                    <span className={clsx(styles.hourHand, playing && styles.animatedHour)}/>
                    <span className={clsx(styles.minuteHand, playing && styles.animatedMinute)}/>
                    <span className={styles.centreCap}/>
                </div>
                <div className={styles.digits}>
                    <div className={styles.digitBox}>
                        <span className={clsx(styles.digit, playing && styles.digit1)}>0</span>
                        <span className={clsx(styles.digit, playing && styles.digit2)}>6</span>
                    </div>
                    <span>:</span>
                    <div className={styles.digitBox}>
                        <span className={clsx(styles.digit, playing && styles.digit3)}>2</span>
                        <span className={clsx(styles.digit, playing && styles.digit4)}>9</span>
                    </div>
                </div>
            </div>
            <div className={clsx(styles.feedback, playing && styles.rise)}>
                <CheckCircleBoldIcon size={26} color="var(--color-feedback-correct-vivid)"/>
                <span className={styles.feedbackText}>The correct answer is 6:29.</span>
            </div>
        </>
    );
}
